import React from 'react';
import PropTypes from 'prop-types';
import Grid from '../components/Grid.jsx';
import FormikFormattedTextField from '../formik-fields/FormikFormattedTextField.jsx';

const GridFormikFormattedTextField = ({ gridProps, ...props }) => {
  return (
    <Grid item {...gridProps}>
      <FormikFormattedTextField {...props} />
    </Grid>
  );
};

GridFormikFormattedTextField.propTypes = {
  disabled: PropTypes.bool,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.any,
  fieldProps: PropTypes.object,
  gridProps: PropTypes.object.isRequired,
  formatText: PropTypes.func.isRequired,
  unformatText: PropTypes.func.isRequired,
};

export default GridFormikFormattedTextField;
